import { render, staticRenderFns } from "./PageImageAvatar.vue?vue&type=template&id=79f42ff8"
import script from "./PageImageAvatar.vue?vue&type=script&lang=js"
export * from "./PageImageAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79f42ff8')) {
      api.createRecord('79f42ff8', component.options)
    } else {
      api.reload('79f42ff8', component.options)
    }
    module.hot.accept("./PageImageAvatar.vue?vue&type=template&id=79f42ff8", function () {
      api.rerender('79f42ff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/PageImageAvatar.vue"
export default component.exports